import { useTranslation } from "react-i18next";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "src/components/ui/dialog";
import Button from "./Button";

interface MigrationSchedulingModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export default function MigrationSchedulingModal({
  open,
  onOpenChange,
}: MigrationSchedulingModalProps) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="sm:max-w-[500px]"
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle className="text-xl">
            {t(
              "migration:time-to-migrate",
              "⚠️ ActiveCampaign Migration Confirmation"
            )}
          </DialogTitle>
          <DialogDescription className="text-base pt-2">
            {t(
              "migration:migration-description",
              "Hilos will stop working on June 26th and we have not yet received your confirmation. We have reached out by email, but we want to make sure you don't lose service. To keep your number and continue operating without interruptions, please write to us at "
            )}
            <a
              href="mailto:hey@hilos.io"
              className="text-hilos underline"
            >
              hey@hilos.io
            </a>
            {"."}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="sm:justify-end gap-2">
          <Button variant="contained" onClick={() => onOpenChange(false)}>
            {t("migration:understood", "Understood")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
